import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import {
  View,
  ScrollView,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  Dimensions,
  Alert,
} from "react-native";
import TouchableOpacity from "app/components/TouchableOpacity";
import Text from "app/components/Text";
import chapterActions from "app/utils/chapterActions";
import storageActions from "app/utils/storageActions";
import valueActions from "app/utils/valueActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import textHelpers from "app/utils/textHelpers";
import valueHelpers from "app/utils/valueHelpers";
import colorHelpers from "app/utils/colorHelpers";
import timeHelpers from "app/utils/timeHelpers";

import MomentBullet from "app/components/chapter/MomentBullet";
import MomentList from "app/components/chapter/MomentList";
import Chapter from "app/components/Chapter";
import Icon from "app/components/Icon";
import Badge from "app/components/chapter/Badge";
import HoverableTooltip from "app/components/HoverableTooltip";

import store from "app/redux/store";
import {
  Ionicons,
  Octicons,
  FontAwesome,
  Feather,
  Entypo,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

import { StyleContext } from "app/contexts/Style";

const USE_LEGEND = true;
const LEGEND = [
  { title: "Health", icon: "apple", color: "red" },
  { title: "Introspection", icon: "notebook", color: "brown" },
  { title: "Creativity", icon: "paints", color: "orange" },
  { title: "Dev", icon: "code", color: "yellow" },
  { title: "Community", icon: "community", color: "blue" },
  { title: "Romance", icon: "hearts", color: "pink" },
];

export default class Profile extends React.Component {
  static contextType = StyleContext;
  constructor(props, context) {
    super(props, context);
    let { navigation, route } = this.props;

    this.state = {
      chapters: [],
      dayChapters: [],
      subChapters: [],
      allMoments: [],
      weeks: [],
      loading: true,
      fetching: true,
      selectedDate: route.params?.date,
      sortedColors: Object.keys(colorHelpers.allColors(context.colorScheme)),
      selectedValue: null,
    };
  }

  async componentDidMount() {
    this.fetch();
  }

  fetch = async () => {
    this.setState({ fetching: true });
    let { selectedDate, sortedColors } = this.state;
    let range = "week";
    let res;
    res = await storageActions.fetchItem("profile_res");
    if (!res) {
      res = await chapterActions.timeline(0);
      storageActions.saveItem("profile_res", res);
    }
    if (res?.success) {
      let chapters = res.chapters;
      let dayChapters = textHelpers.oldestFirst(
        chapters.filter((c) => c.range == 1),
        "start_at",
      );
      dayChapters = dayChapters.filter(
        (x) => x.start_at <= timeHelpers.dateTimeToDate(),
      );
      let moments = [];
      let weeks = [];

      if (USE_LEGEND) {
        dayChapters = dayChapters.map((c) => ({
          ...c,
          moments: this.applyCategories(c.moments),
        }));
      }

      let weekdayOffset = new Date(dayChapters[0].start_at).getDay();
      let endingWeekdayOffset =
        6 - new Date(dayChapters[dayChapters.length - 1].start_at).getDay();
      let startOfFinalWeek = timeHelpers.dateTimeToDate(
        timeHelpers.beginningOfWeek(
          dayChapters[dayChapters.length - 1].start_at,
        ),
      );

      let isFirstWeek = true;
      let isLastWeek = false;
      dayChapters.forEach((chapter, i) => {
        let sortedMoments = chapter.moments;
        moments = [...moments, ...sortedMoments];

        let weekLength = 7;
        if (isFirstWeek) {
          let dow = new Date(chapter.start_at).getDay();
          if (dow == 0) {
            isFirstWeek = false;
            // weekdayOffset = 0;
          } else {
            weekLength -= weekdayOffset;
          }
        }
        if (startOfFinalWeek == chapter.start_at) isLastWeek = true;
        if (isLastWeek) {
          weekLength -= endingWeekdayOffset;
        }

        let weekIndex = Math.floor((i + weekdayOffset) / 7);
        // console.log(
        //   textHelpers.formatDate(chapter.start_at, true),
        //   `week:${weekIndex}`,
        //   `myOffset:${new Date(chapter.start_at).getDay()}`,
        //   `day:${i}`,
        //   `pos:${i + weekdayOffset}`,
        //   `offset:${weekdayOffset}`,
        //   `weekLength:${weekLength}`,
        // );
        if (!weeks[weekIndex]) {
          weeks[weekIndex] = { weekLength, moments: sortedMoments };
        } else {
          weeks[weekIndex].moments = [
            ...weeks[weekIndex].moments,
            ...sortedMoments,
          ];
        }
      });
      let allMoments = [...moments].sort((a, b) =>
        sortedColors.indexOf(a.value.color) >
        sortedColors.indexOf(b.value.color)
          ? 1
          : -1,
      );
      // console.log("MOMENTS", moments);

      let startAt = dayChapters[0].start_at;
      let endAt = dayChapters[dayChapters.length - 1].start_at;
      let range = Math.ceil(timeHelpers.daysAgo(startAt, endAt));

      let start = 0;
      let end = range;

      let values = [];
      // allMoments.forEach((m) => {
      //   if (!values.find((v) => v.id == m.value.id)) values.push(m.value);
      // });
      // console.log("VALUES", values);
      // let parentIds = values.map((v) => v.parent_ids).flat();
      // let parentValues = await valueActions.index(parentIds);
      // console.log("PARENTS", parentValues);

      await this.setState({
        chapters: res.chapters,
        dayChapters,
        allMoments,
        weeks,
        loading: false,
        fetching: false,
      });
    }
    return;
    // let res = await chapterActions.current(range, selectedDate);
    console.log(res);
    if (res?.success) {
      await this.setState({
        chapters: res.top_chapters,
        subChapters: res.sub_chapters,
        loading: false,
        fetching: false,
      });
    } else {
      let error = res?.error || "error";
      console.warn(error);
    }
  };

  applyCategories = (moments) => {
    return moments.map((moment) => {
      let color = moment.value.color;
      let icon = moment.value.icon;
      let category;
      if (
        ["rocket", "community", "charity", "city", "yin-yang"].includes(icon)
      ) {
        category = "Community";
      } else if (icon == "piano") {
        category = "Creativity";
      } else if (icon == "cloud-moon" || color == "cream") {
        category = "Introspection";
      } else if (icon == "gamepad") {
        category = "Dev";
      }
      if (category) {
        let obj = LEGEND.find((l) => l.title == category);
        color = obj.color;
        icon = obj.icon;
      }

      return {
        ...moment,
        value: {
          ...moment.value,
          color,
          icon,
        },
      };
    });
  };

  render() {
    let {
      dayChapters,
      allMoments,
      weeks,
      chapters,
      subChapters,
      sortedColors,
      loading,
      selectedValue,
    } = this.state;

    return (
      <View style={[this.styles().container]}>
        <StatusBar style="auto" />

        <View style={{ height: this.context.sizes.base }} />

        <ScrollView style={this.styles().scroller}>
          {loading && <ActivityIndicator />}

          {/*<Text>Month</Text>*/}
          <View style={this.styles().timeframRow}>
            <View style={this.styles().timeframeChunk}>
              {this.context.sizes.WIDTH > 600 && (
                <Text center numberOfLines={1} style={{ textOverflow: "clip" }}>
                  {!!dayChapters?.length
                    ? timeHelpers.getMonthName(dayChapters[0].start_at)
                    : ""}
                </Text>
              )}
              {allMoments.map((m, i) => {
                return this.renderMomentBlock(m, i);
              })}
            </View>
          </View>

          {/*<Text>Weeks</Text>*/}
          <View style={this.styles().timeframRow}>
            {weeks.map((week, i) => {
              let indexAgo = weeks.length - 1 - i;
              return (
                <View key={i} style={{ flex: week.weekLength }}>
                  {this.context.sizes.WIDTH > 600 && (
                    <Text
                      center
                      numberOfLines={1}
                      style={{ textOverflow: "clip" }}
                    >
                      {indexAgo == 0
                        ? "Current Week"
                        : indexAgo == 1
                        ? "Last Week"
                        : `${indexAgo} Weeks Ago`}
                    </Text>
                  )}
                  <View style={this.styles().timeframeChunk}>
                    {week.moments
                      .sort((a, b) =>
                        sortedColors.indexOf(a.value.color) >
                        sortedColors.indexOf(b.value.color)
                          ? 1
                          : -1,
                      )
                      .map((m, i) => {
                        return this.renderMomentBlock(m, i);
                      })}
                  </View>
                </View>
              );
            })}
          </View>

          {/*<Text>Days</Text>*/}
          <View style={this.styles().timeframRow}>
            {dayChapters.map((chapter, i) => {
              //return <Chapter key={i} chapter={chapter} />;
              return (
                <View key={i} style={{ flex: 1 }}>
                  {this.context.sizes.WIDTH > 600 && (
                    <Text
                      center
                      numberOfLines={1}
                      style={{ textOverflow: "clip" }}
                      onPress={() => {
                        chapter.moments.forEach((m) => {
                          console.log(
                            m.value.color,
                            sortedColors.indexOf(m.value.color),
                          );
                        });

                        console.log(
                          sortedColors,

                          chapter.moments.sort((a, b) =>
                            sortedColors.indexOf(a.value.color) >
                            sortedColors.indexOf(b.value.color)
                              ? 1
                              : -1,
                          ),
                        );
                      }}
                    >
                      {textHelpers
                        .formatDate(chapter.start_at, true, false, false)
                        .slice(2)}
                    </Text>
                  )}
                  <View style={this.styles().timeframeChunk}>
                    {chapter.moments
                      .sort((a, b) =>
                        sortedColors.indexOf(a.value.color) >
                        sortedColors.indexOf(b.value.color)
                          ? 1
                          : -1,
                      )
                      .map((moment, j) => {
                        return this.renderMomentBlock(moment, j, true);
                      })}
                  </View>
                </View>
              );
            })}
          </View>

          {!!selectedValue && (
            <View style={{ margin: 20 }}>
              <MomentBullet
                moment={{ value: selectedValue }}
                onEscape={() => this.setState({ selectedValue: null })}
              />
            </View>
          )}

          {this.renderLegend()}
        </ScrollView>
      </View>
    );
  }

  renderMomentBlock = (moment, i, includeIcon = false) => {
    let value = moment.value;
    let valueColor =
      valueHelpers.colorAsHex(value?.color, this.context.colorScheme) ||
      this.context.colors.foreground;
    let dimColor = colorHelpers.modifyHex(valueColor, ENV.LIGHT ? 0.8 : 0.5);
    return (
      <View
        key={Math.random()}
        style={[
          this.styles().block,
          {
            zIndex: 999 - i,
            backgroundColor: valueColor,
            borderBottomWidth: includeIcon ? 0.1 : 0,
            borderColor: this.context.colors.empty,
          },
        ]}
      >
        <HoverableTooltip floatingLeft text={value.title} style={{ flex: 1 }}>
          <TouchableOpacity
            onPress={() => {
              console.log(value);
              this.setState({ selectedValue: value });
            }}
            style={{ flex: 1 }}
          >
            <View
              style={{
                display: "none",
                position: "absolute",
                top: 2,
                left: 2,
                bottom: 0,
                right: 0,
                // borderWidth: 1,
                overflow: "hidden",
              }}
            >
              {/*<Text style={{ color: dimColor }}>{value.title}</Text>*/}
              {includeIcon && (
                <Icon
                  color={dimColor}
                  size={14}
                  name={valueHelpers.getIcon(value)}
                />
              )}
            </View>
          </TouchableOpacity>
        </HoverableTooltip>
      </View>
    );
  };

  renderLegend = () => {
    if (USE_LEGEND) {
      return (
        <View style={{ marginTop: this.context.sizes.large }}>
          <View style={{ flexDirection: "row" }}>
            <View style={{ flex: 3 }} />
            <View
              style={{
                flex: 1,
                borderBottomWidth: 1,
                borderColor: this.context.colors.foreground,
              }}
            >
              <Text>Legend</Text>
            </View>
            <View style={{ flex: 3 }} />
          </View>
          {Object.keys(LEGEND).map((key) => {
            let obj = LEGEND[key];
            let color = valueHelpers.colorAsHex(
              obj.color,
              this.context.colorScheme,
            );
            return (
              <View style={{ flexDirection: "row" }}>
                <View style={{ flex: 3 }} />
                <View
                  style={{
                    flex: 1,
                    flexDirection: "row",
                    justifyContent: "flex-start",
                  }}
                >
                  {/*<Badge moment={{ value: obj }} />*/}
                  <Icon
                    name={obj.icon}
                    color={color}
                    size={this.context.sizes.large}
                    style={{ marginRight: 6 }}
                  />
                  <Text style={{ color: color }}>{obj.title}</Text>
                </View>
                <View style={{ flex: 3 }} />
              </View>
            );
          })}
        </View>
      );
    }
    let { allMoments } = this.state;
    let uniqueColors = {};
    allMoments.forEach((m) => {
      let color = m.value.color;
      if (!!color) {
        if (!!uniqueColors[color]) {
          if (!uniqueColors[color].includes(m.value.icon)) {
            uniqueColors[color].push(m.value.icon);
          }
        } else {
          uniqueColors[color] = [m.value.icon];
        }
      }
    });
    return (
      <View style={{ marginTop: this.context.sizes.large }}>
        <Text center>Legend</Text>
        <View style={{ flex: 1, flexDirection: "row" }}>
          <View style={{ flex: 1 }} />
          <View style={{ flex: 5 }}>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              {Object.keys(uniqueColors).map((color) => {
                return uniqueColors[color].map((icon, i) => {
                  return (
                    <View
                      key={i}
                      style={{
                        paddingRight: this.context.sizes.base,
                        paddingBottom: this.context.sizes.base,
                      }}
                    >
                      <Icon
                        color={valueHelpers.colorAsHex(
                          color,
                          this.context.colorScheme,
                        )}
                        name={icon}
                        size={this.context.sizes.large}
                      />
                    </View>
                  );
                });
              })}
            </View>
          </View>
          <View style={{ flex: 1 }} />
        </View>
      </View>
    );
  };

  styles = () => ({
    container: {
      flex: 1,
      // alignItems: 'center',
      // alignItems: 'stretch',
    },
    contentWrapper: {
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "flex-start",
      flex: 1,
    },
    content: {
      // alignSelf: 'center',
      // alignItems: 'center',
      // flex: 1,
      // borderWidth: 1, borderColor: 'red',
      // maxWidth: WIDTH/2,
    },
    scroller: {
      // padding: this.context.sizes.base,
    },
    timeframRow: {
      flex: 1,
      flexDirection: "row",
      minHeight: 140,
    },
    timeframeChunk: {
      flex: 1,
      borderColor: this.context.colors.empty,
      borderWidth: 1,
      alignItems: "stretch",
    },
    block: {
      flex: 1,
      flexGrow: 1,
      position: "relative",
    },
  });
}
